<template>
  <div id="index">
    <header-Top :topBgimg="require('../assets/new_index_bg1.png')" descType="index" :topImgShow="true"></header-Top>
    <div class="header-bottom flex_rowC">
      <div class="header-bottom-panel flex_row_between">
        <div class="header-bottom-panel-item flex_colC">
          <div>
            <div class="title">5万+</div>
            <div class="desc">服务企业客户案例</div>
          </div>
        </div>
        <div class="header-bottom-panel-item flex_colC">
          <div>
            <div class="title">2W+</div>
            <div class="desc">专业HR联盟社群</div>
          </div>
        </div>
        <div class="header-bottom-panel-item flex_colC">
          <div>
            <div class="title">100W+</div>
            <div class="desc">累计出具背调报告</div>
          </div>
        </div>
        <div class="header-bottom-panel-item flex_colC">
          <div>
            <div class="title">1亿+</div>
            <div class="desc">年背调行为数据</div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 30px"></div>
    <div class="index-main">
      <div class="index-main-item relative index-main-item0">
        <div class="title">
          我们的产品
        </div>
        <div class="desc">
          4大产品线，服务企业招人选人全流程
        </div>
        <div class="content1" style="z-index: 999">
          <div class="flex_row_between">
            <div class="tab"
                 :class="tabIndex == index ? 'tab-on' : 'tab-out'"
                 @click="checkTabs(index)" v-for="(item,index) in tabList" :key="index">{{item}}</div>
          </div>
          <div class="flex_colC flex_grow_1 panel">
            <div class="panel_items flex_row_around W_100 relative" style="" v-show="tabIndex == 0">
              <div class="flex_col_between panel_items_left" style="margin-right: 20px;z-index: 99;background-color: #ffffff">
                <img src="@/assets/new_index_product_icon1.png" alt="">
                <div class="title1">
                  猎头的服务，内推的费用
                </div>
                <div class="title2">
                  <div>1W+人才推荐官精准推荐</div>
                  <div>招到人，再结算</div>
                  <div>企业招聘效率大幅提升</div>
                </div>
                <div class="btn">
                  <button class="btn1 fontSize_16" @click="toRegPage">立即免费试用</button>
                  <button class="fontSize_16 more_btn" @click="showCode">了解更多</button>
                </div>
              </div>
              <img src="@/assets/new_index_product_img1.png" class="" alt="">
              <img src="@/assets/new_index_product_img5.png" class="absolute" style="right: -3%;bottom: -43%;z-index: -1">
            </div>
            <div class="panel_items flex_row_around W_100 relative" v-show="tabIndex == 1">
              <div class="flex_col_between panel_items_left" style="margin-right: 20px;z-index: 99;background-color: #ffffff">
                <img src="@/assets/new_index_product_icon2.png" alt="">
                <div class="title1">
                  雇前背景调查
                </div>
                <div class="title2">
                  <div>大数据履历核实，真实客观</div>
                  <div>43个套餐适配主流行业&岗位</div>
                  <div>帮助企业远离用工风险</div>
                </div>
                <div class="btn">
                  <button class="btn1 fontSize_16">立即免费试用</button>
                  <button class="fontSize_16 more_btn" @click="$router.push('/backdropInquiry')">了解更多</button>
                </div>
              </div>
              <img src="@/assets/new_index_product_img3.png" alt="">
              <img src="@/assets/new_index_product_img5.png" class="absolute" style="right: -3%;bottom: -43%;z-index: -1">
            </div>
            <div class="panel_items flex_row_around W_100 relative" v-show="tabIndex == 2">
              <div class="flex_col_between panel_items_left" style="margin-right: 20px;z-index: 99;background-color: #ffffff">
                <img src="@/assets/new_index_product_icon3.png" alt="">
                <div class="title1">
                  招聘损失补偿保障
                </div>
                <div class="title2">
                  <div>国内唯一保险公司承保平台</div>
                  <div>员工试用期离职</div>
                  <div>企业损失最高补偿300%</div>
                </div>
                <div class="btn">
                  <button class="btn1 fontSize_16" @click="toLogin">立即免费试用</button>
                  <button class="fontSize_16 more_btn" @click="dialogTableVisible=!dialogTableVisible">了解更多</button>
                </div>
              </div>
              <img src="@/assets/new_index_product_img4.png" alt="">
              <img src="@/assets/new_index_product_img5.png" class="absolute" style="right: -3%;bottom: -43%;z-index: -1">
            </div>
            <div class="panel_items flex_row_around W_100 relative" v-show="tabIndex == 3">
              <div class="flex_col_between panel_items_left" style="margin-right: 20px;z-index: 99;background-color: #ffffff">
                <img src="@/assets/new_index_product_icon4.png" alt="">
                <div class="title1">
                  永久职业档案
                </div>
                <div class="title2">
                  <div>数字化员工关系管理</div>
                  <div>技能云，员工激励</div>
                </div>
                <div class="btn">
                  <button class="btn1 fontSize_16" @click="toLogin">立即免费试用</button>
                  <button class="fontSize_16 more_btn" @click="toLogin">了解更多</button>
                </div>
              </div>
              <img src="@/assets/new_index_product_img2.png" alt="">
              <img src="@/assets/new_index_product_img5.png" class="absolute" style="right: -3%;bottom: -43%;z-index: -1">
            </div>
          </div>
        </div>

      </div>
      <div class="index-main-item flex_colC index-main-item1">
        <div>
          <div class="title">
            核心优势
          </div>
          <div class="desc">
            数据驱动，助力精细化时代的人才战略
          </div>
        </div>
        <div class="flex_rowC">
          <div class="items flex_colC" v-for="(item,index) in kernelList" :key="index"
               @mouseenter="onMouseenter(index)" @mouseleave="onMouseleave(index)">
            <div class="icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="titles" style="margin-bottom: 40px;" :class="item.is_select ? 'color_ffffff' : 'color_303133'">
              {{item.title}}
            </div>
            <div class="descs"  :class="item.is_select ? 'color_ffffff' : 'color_606266'" v-for="(asset,idx) in item.desc" :key="idx">
              <div>{{asset}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-main-item flex_colC index-main-item2">
        <div>
          <div class="title">
            为什么选择萝卜猎手？
          </div>
        </div>
        <div class="flex_rowC W_100">
          <div class="items">
            <div class="icon">
              <img src="@/assets/new_index_icon5.png" alt="">
            </div>
            <div class="title1">2016年创立</div>
            <div class="desc">雇前服务领导品牌</div>
          </div>
          <div class="items" style="margin: 0 50px">
            <div class="icon">
              <img src="@/assets/new_index_icon6.png" alt="">
            </div>
            <div class="title1">业界口碑传承</div>
            <div class="desc">5万家优质企业的共同选择</div>
          </div>
          <div class="items" style="margin-right: 50px">
            <div class="icon">
              <img src="@/assets/new_index_icon7.png" alt="">
            </div>
            <div class="title1">数据和算法驱动</div>
            <div class="desc">提高企业人力资源数智化水平</div>
          </div>
          <div class="items">
            <div class="icon">
              <img src="@/assets/new_index_icon8.png" alt="">
            </div>
            <div class="title1">助力企业人才战略</div>
            <div class="desc">激发人才生产力，帮助企业降本增效</div>
          </div>
        </div>
      </div>
      <div class="index-main-item3 flex_col_around" v-if="false">
        <div>
          <div class="title">企业说</div>
          <div class="desc">专注雇前流程服务专家</div>
        </div>
        <div class="swiper-container" v-if="false">
          <div class="swiper-wrapper">
            <div class="swiper-slide">Slide 1</div>
            <div class="swiper-slide">Slide 2</div>
            <div class="swiper-slide">Slide 3</div>
            <div class="swiper-slide">Slide 4</div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>

          <!-- 如果需要导航按钮 -->
          <!--<div class="swiper-button-prev"></div>-->
          <!--<div class="swiper-button-next"></div>-->

          <!-- 如果需要滚动条 -->
          <!--<div class="swiper-scrollbar"></div>-->
        </div>
        <el-carousel :interval="4000" type="card" height="300px">
          <el-carousel-item v-for="item in 6" :key="item">
            <div class="medium">
              {{item}}
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="index-main-item4 flex_col_around">
        <div>
          <div class="title">客户案例</div>
          <div class="desc">50,000+优质企业的共同选择</div>
        </div>

        <div class="W_100" style="margin-bottom: 50px">
          <div class="banner_img">
            <div class="banner_img1">

            </div>
          </div>
          <div class="banner_img" style="margin: 50px 0">
            <div class="banner_img2">

            </div>
          </div>
          <div class="banner_img">
            <div class="banner_img3">

            </div>
          </div>
        </div>
      </div>
      <footer-Nav></footer-Nav>
    </div>
    <!--<div class="fixed" style="right: 2%;top: 50%;" v-if="sideNav">-->
    <div class="fixed" style="right: 2%;top: 50%;">
      <div class="flex_rowC relative" style="top: 10px;z-index: -1">
        <img src="@/assets/index_newsideTop_icon.png" alt="">
      </div>
      <div class="color_ffffff" style="width: 68px;border-radius: 7px;padding: 10px 0;background: #FE8342;
box-shadow: 0px 3px 31px 0px rgba(250, 158, 17, 0.20);z-index: 999">
        <el-popover
          placement="left-start"
          width="118"
          popper-class="WH_0"
          trigger="hover">
          <!-- <img src="@/assets/tupian1.png" style="width: 118px" alt=""> -->
          <img src="@/assets/luobo_shunshun.5899a16.png" style="width: 118px" alt="">
          <div @click="clickNav(0)" slot="reference"
               @mouseenter="onMouseenter1(0)" @mouseleave="onMouseleave1(0)"
               class="textC flex_colC cursorPointer"
               :class="sideNavList[0].is_select ? 'color_FE5903_83' : ''" style="height: 68px">
            <img class="marginAuto" :src="sideNavList[0].icon" alt="">
            <div class="color_ffffff" style="font-size: 14px;margin-top: 5px">{{sideNavList[0].title}}</div>
          </div>
        </el-popover>
        <el-popover
          placement="left-start"
          width="148"
          popper-class="WH_0"
          trigger="hover">
          <div class="" style="padding: 20px 0">
            <div class="flex_rowC">
              <img src="@/assets/index_newsideNav_code2.png" style="width: 118px" alt="">
            </div>
            <div class="textC" style="margin-top: 10px">
              扫一扫，无需下载 <br>
              随时随地便捷使用
            </div>
          </div>
          <div @click="clickNav(1)" slot="reference"
               @mouseenter="onMouseenter1(1)" @mouseleave="onMouseleave1(1)"
               class="textC flex_colC cursorPointer"
               :class="sideNavList[1].is_select ? 'color_FE5903_83' : ''" style="height: 68px">
            <img class="marginAuto" :src="sideNavList[1].icon" alt="">
            <div class="color_ffffff" style="font-size: 14px;margin-top: 5px">{{sideNavList[1].title}}</div>
          </div>
        </el-popover>
        <el-popover
          placement="left-start"
          width="118"
          popper-class="WH_0"
          trigger="hover">
          <img src="@/assets/index_newsideNav_code3.5849324.png" style="width: 118px" alt="">

          <div @click="clickNav(2)" slot="reference"
               @mouseenter="onMouseenter1(2)" @mouseleave="onMouseleave1(2)"
               class="textC flex_colC cursorPointer"
               :class="sideNavList[2].is_select ? 'color_FE5903_83' : ''" style="height: 68px">
            <img class="marginAuto" :src="sideNavList[2].icon" alt="">
            <div class="color_ffffff" style="font-size: 14px;margin-top: 5px">{{sideNavList[2].title}}</div>
          </div>
        </el-popover>
        <div v-for="(item,index) in sideNavList" :key="index"
             v-if="index != 0 && index != 1 && index != 2"
             @click="clickNav(index)"
             @mouseenter="onMouseenter1(index)" @mouseleave="onMouseleave1(index)"
             class="textC flex_colC cursorPointer"
             :class="item.is_select ? 'color_FE5903_83' : ''" style="height: 68px">
          <img class="marginAuto" :src="item.icon" alt="">
          <div class="color_ffffff" style="font-size: 14px;margin-top: 5px">{{item.title}}</div>
        </div>
      </div>
    </div>
    <el-dialog custom-class="dialogClass" width="580px" :visible.sync="dialogTableVisible">
      <div class="dialog_penal PLR_4 PB_6 relative" style="width: 580px">
        <span class="el-icon-close absolute cursorPointer" style="top: 5%;right: 5%;color: #C0C4CC;font-size: 26px" @click="dialogTableVisible=false"></span>
        <div class="title PT_6">
          如何获取招聘保险额度？
        </div>
        <div class="desc color_606266">
          新员工试用期离职会造成企业大量的隐型成本损失，长期不注意规避，容易导致企业成本增高，人力资源部门能力信用受损。
        </div>
        <div class="desc color_606266">
          <span>萝卜猎手针对会员企业，推出</span>
          <span class="cursorPointer" style="color: #4571D0">《招聘保障方案》</span>
          <span>，帮助会员企业避免因员工试用期离职导致的购买简历及背调成本损失。</span>
        </div>
        <div class="flex_rowC">
          <img :src="require('../assets/luobo_shunshun.5899a16.png')" style="width: 113px" alt="">
        </div>
        <div class="flex_colC color_606266 textC" style="padding-bottom: 20px">
          <div class="" style="padding: 10px 0">招错人无可避免，成本却能挽回！</div>
          <div> 测试期间，数量有限，详情请咨询您的专属客服！</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog custom-class="dialogClass" width="317px" :visible.sync="dialogTableVisible1">
      <div class="dialog_penal PLR_4 PB_6 relative" style="width: 317px">
        <span class="el-icon-close absolute cursorPointer" style="top: 5%;right: 5%;color: #C0C4CC;font-size: 26px" @click="dialogTableVisible1=false"></span>

        <div class="flex_colC" style="padding-top: 50px">
          <div class="flex_rowC" style="width: 167px;height: 167px;border: 1px solid #E5E5E5;">
            <img :src="require('../assets/luobo_shunshun.5899a16.png')" style="width: 155px" alt="">
          </div>
        </div>
        <div class="textC" style="padding-bottom: 50px;padding-top: 20px;color: #4571D0;font-size: 18px">
          添加专属顾问  领取免费试用
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Swiper from 'swiper'
  import '@/common/css/index.css'
  import '../common/swiper/css/swiper.min.css'
  import '../common/swiper/js/swiper.min.js'
  import headerTop from '@/components/headerTop';
  import footerNav from '@/components/footerNav';
  import { Dialog } from 'element-ui';
  Vue.use(Dialog);

  export default {
    name: 'index',
    data() {
      return {
        dialogTableVisible:false,
        dialogTableVisible1:false,
        tabList: ['悬赏招聘', '背景调查', '招聘保险', '职业档案'],
        tabIndex: 0,
        loginCode:'',
        sideNav:false,
        kernelList:[
          {
            icon:require('@/assets/new_index_icon2.png'),
            title:'专业',
            desc:['专注雇前流程服务专家','开创和重新定义雇前服务','核心团队来自知名互联网和500强公司'],
            is_select:false
          },
          {
            icon:require('@/assets/new_index_icon3.png'),
            title:'智能',
            desc:['AI+大数据科技驱动，提高行业效率','自研算法，NLP真正落地招聘雇佣','人力资源精细化、标签化、数字化'],
            is_select:false
          },
          {
            icon:require('@/assets/new_index_icon4.png'),
            title:'安全',
            desc:['数据权威客观精准','5年来保护客户隐私，0投诉','国内唯一保险公司承保的背调平台'],
            is_select:false
          }
        ],
        sideNavList:[
          {
            icon:require('@/assets/index_newsideNav_icon1.png'),
            title:'联系客服',
            is_select:false
          },
          {
            icon:require('@/assets/index_newsideNav_icon2.png'),
            title:'移动端',
            is_select:false
          },
          {
            icon:require('@/assets/index_newsideNav_icon3.png'),
            title:'公众号',
            is_select:false
          },
          {
            icon:require('@/assets/index_newsideNav_icon4.png'),
            title:'返回顶部',
            is_select:false
          },
        ]
      }
    },
    created() {
      // console.log(this.$route.query.loginCode);
      if(this.$route.query.loginCode) {
        this.loginCode = this.$route.query.loginCode;
      }
    },
    mounted() {
      window.addEventListener('scroll', this.scrollToTop);
      // let mySwiper = new Swiper('.swiper-container',{
      //   slidesPerView: 3,
      //   spaceBetween: 30,
      //   loop : true,
      //   pagination: {
      //     el: '.swiper-pagination',
      //     type : 'custom',
      //   },
      // });
    },
    methods: {
      // 产品栏切换
      checkTabs(index) {
        this.tabIndex = index;
      },
      //test
      toRegPage(){
        location.href = 'https://cop.luobobeidiao.cn/#/Login'
      },
      showCode(){
        this.dialogTableVisible1 = true
      },
      // 跳转登录
      toLogin(type) {
        let href;
        if(type == 1) {
          if(this.loginCode) {
            href = 'https://cop.luobobeidiao.cn/#/Login' + '/?loginCode=' + this.loginCode;
          } else {
            href = 'https://cop.luobobeidiao.cn/#/Login';
          }
        } else {
          href = 'https://bole.luobobeidiao.cn';
        }

        window.open(href, '_blank');
      },
      toRegister() {
        let href = 'https://cop.luobobeidiao.cn/#/Login';
        if(this.loginCode) {
          href = href + '/?loginCode=' + this.loginCode + '&type=register';
        } else {
          href = href + '/?type=register';
        }
        window.open(href, '_blank');
      },
      // 点击侧边导航栏
      clickNav(index) {
        switch (index) {
          case 0 :

            break;
          case 1 :

            break;
          case 2 :

            break;
          case 3 :
            this.toTop();
            break;

        }
      },
      onMouseenter(index) {
        this.kernelList[index].is_select = true;
        switch (index) {
          case 0 :
            this.kernelList[index].icon = require('@/assets/new_index_icon_checkon2.png');
            break;
          case 1 :
            this.kernelList[index].icon = require('@/assets/new_index_icon_checkon3.png');
            break;
          case 2 :
            this.kernelList[index].icon = require('@/assets/new_index_icon_checkon4.png');
            break;
        }
      },
      onMouseleave(index) {
        this.kernelList[index].is_select = false;
        switch (index) {
          case 0 :
            this.kernelList[index].icon = require('@/assets/new_index_icon2.png');
            break;
          case 1 :
            this.kernelList[index].icon = require('@/assets/new_index_icon3.png');
            break;
          case 2 :
            this.kernelList[index].icon = require('@/assets/new_index_icon4.png');
            break;
        }
      },
      onMouseenter1(index) {
        return
        this.sideNavList[index].is_select = true;
        switch (index) {
          case 0 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon1_on.png');
            break;
          case 1 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon2_on.png');
            break;
          case 2 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon3_on.png');
            break;
          case 3 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon4_on.png');
            break;
        }
      },
      onMouseleave1(index) {
        return
        this.sideNavList[index].is_select = false;
        switch (index) {
          case 0 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon1.png');
            break;
          case 1 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon2.png');
            break;
          case 2 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon3.png');
            break;
          case 3 :
            this.sideNavList[index].icon = require('@/assets/index_sideNav_icon4.png');
            break;
        }
      },
      // 页面滚动监听
      scrollToTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(scrollTop);
        if(scrollTop > 1800) {
          this.sideNav = true;
        } else {
          this.sideNav = false;
          this.sideNavList[3].icon = require('@/assets/index_newsideNav_icon4.png');
          this.sideNavList[3].is_select = false;
        }
      },
      toTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = scrollTop -= 30;
          if(scrollTop <= 0) {
            clearInterval(timeTop);
          }
        })
      },
    },
    components: {
      headerTop,
      footerNav
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .swiper-container {
    width: 100%;
    height: 377px;
  }

  .swiper-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .swiper-slide {
    /*width: 774px !important;*/
    height: 300px;
    background: #FFFFFF;
    box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.2);
    border-radius: 28px;
    /*margin-bottom: 50px;*/
  }
  .swiper-pagination {
    width: 100%;
    height: 30px;
    background-color: red;
  }
  .swiper-pagination-bullet {
    width: 50px;
    height: 6px;
    background: #FFFFFF;
    opacity: 0.3;
    border-radius: 0;
  }

  .swiper-pagination-bullet-active {
    background: rgba(254, 89, 3, 0.83);
  }
  /deep/ .el-dialog {
    border-radius: 20px;
  }
  /deep/ .el-dialog__header {
    display: none;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    color: #000000;
  }
  .dialog_penal {

  }
  .dialog_penal .title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0;
  }
  .dialog_penal .desc {
    line-height: 25px;
    padding: 20px;
  }


  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel--horizontal {
    width: 100%;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #ffffff;
    border-radius: 28px;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #ffffff;
    border-radius: 28px;
  }
  .medium {
    border-radius: 28px;
  }
  .WH_0 {

  }
</style>



// WEBPACK FOOTER //
// src/view/index.vue